import { api } from './client';
import type {
  AccessLogsPage,
  AdminSettings,
  BlacklistItem,
  WhitelistItem,
} from './types';

export const adminApi = {
  // Blacklist
  listBlacklist: () => api.get<{ items: BlacklistItem[] }>('/api/admin/blacklist'),
  addBlacklist: (ip: string, reason?: string) =>
    api.post<BlacklistItem>('/api/admin/blacklist', { ip, reason }),
  removeBlacklist: (ip: string) =>
    api.del<{ ok: true }>(`/api/admin/blacklist/${encodeURIComponent(ip)}`),

  // Whitelist
  listWhitelist: () => api.get<{ items: WhitelistItem[] }>('/api/admin/whitelist'),
  addWhitelist: (ip: string, description?: string) =>
    api.post<WhitelistItem>('/api/admin/whitelist', { ip, description }),
  removeWhitelist: (ip: string) =>
    api.del<{ ok: true }>(`/api/admin/whitelist/${encodeURIComponent(ip)}`),

  // Settings
  getSettings: () => api.get<AdminSettings>('/api/admin/settings'),
  patchSettings: (body: Partial<AdminSettings>) => api.patch<AdminSettings>('/api/admin/settings', body),

  // Access Logs
  accessLogs: (limit = 50, before?: number) => {
    const qs = new URLSearchParams();
    qs.set('limit', String(limit));
    if (before !== undefined) qs.set('before', String(before));
    return api.get<AccessLogsPage>(`/api/admin/access-logs?${qs.toString()}`);
  },
};
